var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _linearGradient18, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconApron(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 510 510",
    height: 512,
    viewBox: "0 0 510 510",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fef056"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fe860a"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    xlinkHref: "#lg1",
    y1: 0,
    y2: 71.448
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: -17.959,
    x2: 130.054,
    xlinkHref: "#lg1",
    y1: 159.96,
    y2: 307.973
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fe860a",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8425,
    stopColor: "#fe7a03",
    stopOpacity: 0.843
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fe7701"
  }))), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 38.176,
    x2: 60.928,
    xlinkHref: "#lg2",
    y1: 257.173,
    y2: 234.422
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 82.059,
    x2: 60.507,
    xlinkHref: "#lg2",
    y1: 205.556,
    y2: 227.109
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 382.135,
    x2: 555.276,
    xlinkHref: "#lg1",
    y1: 133.865,
    y2: 307.007
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientTransform: "matrix(-1 0 0 1 114.828 0)",
    gradientUnits: "userSpaceOnUse",
    x1: -356.996,
    x2: -334.245,
    xlinkHref: "#lg2",
    y1: 257.173,
    y2: 234.422
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientTransform: "matrix(-1 0 0 1 114.828 0)",
    gradientUnits: "userSpaceOnUse",
    x1: -313.113,
    x2: -334.665,
    xlinkHref: "#lg2",
    y1: 205.556,
    y2: 227.109
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 80.911,
    x2: 474.93,
    y1: 134.194,
    y2: 528.213
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#596c76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#444"
  }))), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg3"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#444",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  }))), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 401.86,
    x2: 168.42,
    xlinkHref: "#lg3",
    y1: 460.428,
    y2: 222.998
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    xlinkHref: "#lg3",
    y1: 451.105,
    y2: 517.136
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 224.533,
    x2: 298.03,
    y1: 243.59,
    y2: 431.081
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffa799"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fe0364"
  }))), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg4"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d2024e",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c00148"
  }))), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    xlinkHref: "#lg4",
    y1: 362.5,
    y2: 185.483
  })), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    xlinkHref: "#lg4",
    y1: 369.105,
    y2: 430.471
  })), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    xlinkHref: "#lg1",
    y1: 241.942,
    y2: 315.254
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m356.167 71.448h-15c0-14.527-8.581-28.386-24.163-39.024-16.458-11.236-38.479-17.424-62.004-17.424-23.526 0-45.545 6.188-62.003 17.424-15.582 10.638-24.163 24.497-24.163 39.024h-15c0-19.635 10.905-37.894 30.706-51.412 18.924-12.92 43.947-20.036 70.46-20.036s51.536 7.116 70.461 20.036c19.801 13.518 30.706 31.777 30.706 51.412z",
    fill: "url(#SVGID_1_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m7.51 333.617c-4.302 0-7.747-3.614-7.497-7.909 1.896-32.641 15.513-63.063 38.824-86.373l10.339-10.338-26.196-26.195c-20.291-20.292-20.291-53.311 0-73.604l2.371-2.37c10.072-10.069 23.703-16.007 37.944-15.871 15.203.146 29.373 6.771 39.347 18.567 6.916 8.179 11.133 18.393 12.006 29.069 1.269 15.527-4.201 30.346-15.064 41.209l-29.195 29.195 35.95 35.949-10.609 10.607-35.949-35.949-10.338 10.338c-20.683 20.682-32.766 47.671-34.455 76.63-.23 3.958-3.513 7.045-7.478 7.045zm55.271-207.645c-9.486 0-18.973 3.611-26.194 10.833l-3.001 3c-14.443 14.444-14.443 37.946.001 52.39l26.195 26.195 29.194-29.195c6.998-6.997 10.852-16.3 10.852-26.195s-3.854-19.198-10.851-26.195c-7.223-7.221-16.709-10.833-26.196-10.833z",
    fill: "url(#SVGID_2_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.407 289.12c5.874-14.488 14.649-27.791 26.037-39.179l10.338-10.338-10.606-10.607-10.339 10.338c-11.305 11.305-20.322 24.287-26.836 38.379z",
    fill: "url(#SVGID_3_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m95.566 180.281c-1.715 3.243-3.922 6.247-6.59 8.915l-29.194 29.194v.001l10.607 10.607 29.195-29.195c5.603-5.603 9.764-12.26 12.313-19.521h-16.331z",
    fill: "url(#SVGID_4_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m502.49 333.617c-3.965 0-7.248-3.087-7.479-7.046-1.689-28.958-13.772-55.948-34.455-76.63l-10.338-10.338-35.949 35.949-10.607-10.607 35.95-35.949-29.195-29.195c-10.863-10.863-16.333-25.682-15.064-41.209.873-10.676 5.09-20.89 12.006-29.069 9.974-11.796 24.144-18.421 39.347-18.567 14.241-.136 27.872 5.802 37.944 15.871l2.371 2.37c20.291 20.293 20.291 53.311 0 73.604l-26.196 26.195 10.339 10.338c23.311 23.311 36.927 53.732 38.824 86.373.249 4.296-3.195 7.91-7.498 7.91zm-81.467-196.812c-6.997 6.997-10.85 16.3-10.85 26.195 0 9.896 3.854 19.198 10.852 26.195l29.194 29.195 26.195-26.195c14.444-14.444 14.444-37.946.001-52.39l-3.001-3c-7.222-7.222-16.708-10.833-26.194-10.833-9.488 0-18.974 3.612-26.197 10.833z",
    fill: "url(#SVGID_5_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m486.593 289.12c-5.874-14.488-14.649-27.791-26.037-39.179l-10.338-10.338 10.606-10.607 10.339 10.338c11.305 11.305 20.322 24.287 26.836 38.379z",
    fill: "url(#SVGID_6_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m414.434 180.281c1.715 3.243 3.922 6.247 6.59 8.915l29.194 29.195v.001l-10.607 10.607-29.195-29.195c-5.603-5.603-9.764-12.26-12.313-19.521h16.331z",
    fill: "url(#SVGID_7_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m356.738 76.784c1.557-13.239-10.392-24.068-23.414-21.22-51.606 11.289-105.042 11.289-156.647 0-13.022-2.848-24.971 7.981-23.414 21.22 6.404 54.432-7.183 109.336-38.233 154.499l-16.865 24.531c-4.624 6.726-7.1 14.696-7.1 22.858v202.122c0 8.562 6.213 15.859 14.666 17.225 98.872 15.974 199.667 15.974 298.539 0 8.453-1.366 14.666-8.663 14.666-17.225v-202.122c0-8.162-2.475-16.132-7.1-22.858l-16.865-24.531c-31.05-45.163-44.637-100.068-38.233-154.499z",
    fill: "url(#SVGID_8_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m336.75 244.5c0 9.243-7.493 16.735-16.735 16.735h-127.73c-9.13 0-16.531 7.401-16.531 16.531v82.218c0 16.363 7.452 30.984 19.147 40.659l108.119 108.119c33.871-1.74 67.672-5.317 101.25-10.742 8.066-2.017 14.665-10.469 14.665-18.783v-117.404-7.119-28.028z",
    fill: "url(#SVGID_9_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m91.065 403.105v77.689c0 8.562 6.213 15.859 14.666 17.225 98.872 15.974 199.667 15.974 298.539 0 8.453-1.366 14.665-8.663 14.665-17.225v-77.689z",
    fill: "url(#SVGID_10_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m282.502 411.728h-55.005c-29.129 0-52.743-23.614-52.743-52.743v-82.218c0-9.13 7.401-16.531 16.531-16.531h127.429c9.13 0 16.531 7.401 16.531 16.531v82.218c.001 29.129-23.613 52.743-52.743 52.743z",
    fill: "url(#SVGID_11_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m302.307 407.869c19.313-7.832 32.939-26.762 32.939-48.885v-82.217c0-9.13-7.401-16.531-16.531-16.531h-127.43c-9.13 0-16.531 7.401-16.531 16.531v3.55z",
    fill: "url(#SVGID_12_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m282.502 411.728h-55.005c-29.129 0-52.743-23.614-52.743-52.743h160.492c0 29.129-23.614 52.743-52.744 52.743z",
    fill: "url(#SVGID_13_)"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m333.48 281.144c-51.691 19.453-105.27 19.452-156.96 0-4.152-1.562-7.02-6.552-7.02-12.238 0-14.457 0-.108 0-14.565 0-8.327 5.985-14.449 12.095-12.305 48.423 16.992 98.387 16.992 146.811 0 6.11-2.144 12.095 3.978 12.095 12.305v14.565c-.001 5.685-2.869 10.675-7.021 12.238z",
    fill: "url(#SVGID_14_)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconApron);
export default __webpack_public_path__ + "static/media/icon-apron.1483b8278d9f03b5e035be6d314cd241.svg";
export { ForwardRef as ReactComponent };